import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const jiraHomeRoute: InvariantJiraRoute = {
	name: 'for-you',
	path: '/jira/for-you',
};
